export default __webpack_public_path__ + "static/media/Azmeena_Furniturewala.9dbce390.png";